import { render, staticRenderFns } from "./inputBasisInfo.vue?vue&type=template&id=13f87b1a&scoped=true&"
import script from "./inputBasisInfo.vue?vue&type=script&lang=js&"
export * from "./inputBasisInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f87b1a",
  null
  
)

export default component.exports